import type { MailboxInfo } from 'owa-client-types';
import type { SearchTableQuery } from 'owa-mail-list-search';
import type { TableView } from 'owa-mail-list-store';
import { requeryGenWebOnRelevanceSort as requeryGenWebOnRelevanceSortAction } from '../actions/requeryGenWebOnRelevanceSort';
import shouldEnableOriginalQueryOnTypeSectionRedesign from './shouldEnableOriginalQueryOnTypeSectionRedesign';

export default function requeryGenWebOnRelevanceSort(
    tableView: TableView,
    mailboxInfo: MailboxInfo,
    actionSource: string | null | undefined
): void {
    const searchTableQuery = tableView.tableQuery as SearchTableQuery;
    if (
        actionSource !== 'MailListSortMenu' ||
        searchTableQuery.searchSortOrder !== 'Hybrid' ||
        (tableView.recentRowKeys?.length ?? 0) > 0 ||
        searchTableQuery.searchNumber <= 0 ||
        !shouldEnableOriginalQueryOnTypeSectionRedesign(searchTableQuery, mailboxInfo)
    ) {
        return;
    }

    requeryGenWebOnRelevanceSortAction(
        searchTableQuery.queryString,
        { ...mailboxInfo },
        { ...searchTableQuery.searchScope },
        searchTableQuery.searchNumber - 1
    );
}
